













import { mapState } from "vuex";

import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { Tenant } from "@/interfaces/tenants";

@Component({
  computed: {
    ...mapState(["tenants"])
  },
  components: {}
})
export default class TenantOverview extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];

  // Other Variables
  tenant: Tenant = {
    name: "",
    description: "",
    web_url: "",
    tenant_id: ""
  };

  mounted() {
    this.setTenant(this.$route.params.tenant_id);

    this.$store.commit("clearBreadcrumbs");
    this.$store.commit("pushBreadcrumbs", {
      label: this.tenant.name
    });
  }

  // Watchers
  @Watch("$route")
  onRouteChange(newValue: Route) {
    this.setTenant(newValue.params.tenant_id);
  }

  setTenant(tenantId: string) {
    this.tenants.forEach(tenant => {
      if (tenant.tenant_id === tenantId) {
        this.tenant = tenant;
      }
    });
  }
}
